import { Component } from 'react';
import { Button, CheckBox, DataGrid, Form, Template, TextBox } from 'devextreme-react';
import { EmptyItem, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import UniPopup from '../UniPopup.jsx';
//import ClientCaptcha from 'react-client-captcha';
import { apiGet, apiGetP, apiPost, apiPostP, setCookie } from '../../GanjiTools.jsx';
import Captcha from './Captcha.jsx';

const modes = [
    'login', 'new_psw'
];

class WtLogon extends Component {
    state = {
        mode: 'login',
        userName: '',
        psw: '',
        psw2: '',
        counter: 1,
        message: ' ',
        resetPswPopupVisible: false,
        captchaKeyCounter: 1,
        needsCaptcha: false,
        enteredCaptcha: '',
        logonPage: {},
    };

    checkConnectionP = () => new Promise((resolve, reject) => {
        if (this.props.dontCheckConnection) {
            resolve?.();
            return;
        }

        apiGetP('/api/logon/checkConnection')
            .catch(reject)
            .then(res => {
                let s = res?.resp ?? res;

                if (s !== 'ok') {
                    reject?.('not_ok');
                    //window.onServerFailed?.('not_ok');
                    return;
                }
                resolve?.();
            });
    });

    loadLogonPageDataP = logonPageName => new Promise((resolve, reject) => {
        // if (!(logonPageName?.length > 0)) {
        //     reject?.('No page name.');
        //     return;
        // }

        logonPageName ??= '';

        apiGetP(`/api/logon/loadLogonPage?name=${logonPageName}`)
            .catch(reject)
            .then(res => {
                let { error, logonPage } = res ?? { error: 'No response. ' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }

                resolve?.(logonPage);
            });
    });

    componentDidMount() {
        this.checkConnectionP()
            .catch(err => this.setState({ connectionFailed: true }, () => window.onServerFailed?.(err)))
            .then(() => {
                this.state.connectionFailed = false;

                this.loadLogonPageDataP(this.props.name)
                    .catch(err => window.notif('Error loading page. ', err))
                    .then(logonPage => this.setState({ logonPage }, () => console.log('Logon page: ', logonPage)));
            });

        apiGet("/api/logon/pswRules", res => {
            this.pswRules = res.message;
            this.pswRegEx = res.regex;
        });
    }

    onSuccessLogon = user => {
        window.user = user;
        setCookie("k_bipc_eam_userid", user?.id > 0 ? user.id : '');
        setCookie("k_bipc_eam_logonkey", user?.logonkey ?? '');
        setCookie("k_bipc_eam_user_fullname", user?.fullname ?? '');

        this.props.onSuccessLogon?.(user);
    }

    onLogon = () => {
        /*-------------
        // if (this.needsCaptcha && this.state.enteredCaptcha?.toLowerCase() !== this.captchaCode.toLowerCase()) {
        //     this.setState({ message: 'متن کپچا درست نیست', counter: this.state.counter + 1 });
        //     return;
        // }
        --------------*/
        if (!(this.state.userName?.length > 0)) {
            this.setState({ message: 'نام کاربری وارد نشده است' });
            return;
        }

        apiPostP('/api/logon/logon',
            {
                userName: this.state.userName,
                password: this.state.psw,
                captcha: this.state.needsCaptcha ? this.captchaComponent?.getEnteredCode?.() : ''
            })
            .catch(err => this.setState({ message: 'لاگین میسر نشد: ' + err }, () => console.log(err)))
            .then(res => {
                console.log("logon res = ", res); //////////////-------
                let { error, id, logonkey, needs_captcha, change_password } = res
                    ?? { error: 'No Response.', id: 0, logonkey: '', needs_captcha: undefined, change_password: undefined };

                this.state.needsCaptcha = needs_captcha;

                if (needs_captcha)
                    this.state.captchaKeyCounter++;

                if (error?.length > 0) {
                    this.setState({
                        captchaKeyCounter: this.state.captchaKeyCounter + 1,
                        message: error,
                        mode: 'login',
                        psw: ''
                    });
                    return;
                }

                if (change_password) {
                    window.user = { id, logonkey };
                    this.setState({ mode: 'new_psw', message: 'رمز عبور باید عوض شود' });
                    return;
                }
                this.onSuccessLogon({ id, logonkey });
            });
    }

    onNewPassword = () => {
        if (this.state.psw !== this.state.psw2) {
            this.setState({ message: 'رمز عبور و تکرار آن باید یکی باشند' });
            return;
        }

        console.log(this.pswRegEx);

        /* --------------
        if (new RegExp(this.pswRegEx).test(this.state.psw) !== true) {
            this.setState({ message: this.pswRules });
            return;
        }
        ----------------
        */

        apiPost('/api/logon/new_psw',
            {
                userName: this.state.userName,
                password: this.state.psw2,
                captcha: this.state.needsCaptcha ? this.captchaComponent?.getEnteredCode?.() : ''
            },
            res => {
                if (res.error?.length > 0)
                    this.setState({ message: res.error, needsCaptcha: res.needsCaptcha });
                else
                    this.onSuccessLogon(res?.user);
            },
            err => console.log(err)
        );
    }

    onForgotPassword = () => {
        if (this.state.logonPage.passwordChangeMethod === 'can_reset') {
            this.setState({ resetPswPopupVisible: true });
            return;
        }

        if (this.state.logonPage.passwordChangeMethod === 'can_change') {
            this.setState({ changePswPopupVisible: true });
            return;
        }

        window.notif('برای مشکل رمز ابور با ادمین سامانه تماس بگیرید')

        /*-------
        // return;

        // if (this.needsCaptcha && (!(this.state.enteredCaptcha?.length > 0)
        //     || this.state.enteredCaptcha?.toLowerCase() !== this.captchaCode?.toLowerCase())) {
        //     this.setState({ message: 'متن کپچا درست نیست', counter: this.state.counter + 1 });
        //     return;
        // }
        // if (!(this.state.userName?.length > 0)) {
        //     this.setState({ message: 'نام کاربری را وارد کنید', counter: this.state.counter + 1 });
        //     return;
        // }

        // apiPost('/api/logon/resetPassword',
        //     { userName: this.state.userName, password: this.state.psw },
        //     res => {
        //         if (res.error?.length > 0)
        //             this.setState({ message: res.error });
        //         else
        //             this.setState({ message: "رمز عبور جدید به نشانی شما ایمیل شد" });

        //         if (res.newpsw?.length > 0)
        //             console.log('new password= ', res.newpsw);
        //     },
        //     err => console.log(err)
        // );
        -------*/
    }

    onResetPassword = () => {
        if (this.state.logonPage.passwordChangeMethod !== 'can_reset')
            return;

        this.setState({ message: ' ' }, () =>
            apiPost('/api/logon/resetPassword',
                {
                    userName: this.state.userName,
                    nationalno: this.state.nationalno,
                    mobile: this.state.mobile,
                    captcha: this.captchaForResetPassword?.getEnteredCode?.()
                },
                res => {
                    if (res.error?.length > 0)
                        this.setState({ message: res.error });
                    else
                        this.setState({ message: "رمز عبور جدید به نشانی شما ایمیل شد" });

                    if (res.newpsw?.length > 0) //////////////////////////////////
                        console.log('new password= ', res.newpsw);
                },
                err => console.log(err)
            ));
    }

    render() {
        let needsCaptcha = this.state.needsCaptcha === true;

        return (
            <>
                <div style={{
                    display: 'block', width: '30rem', padding: '3rem', backgroundColor: 'whitesmoke',
                    margin: 'auto', borderRadius: '1rem'
                }}
                >
                    {this.state.connectionFailed
                        ?
                        <h3>ارتباط با سرور میسر نشد</h3>
                        :
                        <Form rtlEnabled={true} colCount={60} //key={'logonForm_' + this.state.captchaKeyCounter}
                        >
                            <SimpleItem colSpan={60}>
                                <Label>
                                    نام کاربری:
                                </Label>
                                <TextBox readOnly={this.state.mode === 'new_psw'}
                                    //---------- onValueChange={e => this.setState({ message: ' ' })}
                                    value={this.state.userName}
                                    onValueChanged={v => this.setState({ userName: v.value })}
                                    onValueChange={() => this.setState({ message: '' })}
                                />
                            </SimpleItem>

                            <SimpleItem colSpan={60}>
                                <Label>
                                    رمز عبور:
                                </Label>
                                <TextBox mode='password'
                                    //---------- onValueChange={e => this.setState({ message: ' ' })}
                                    value={this.state.psw} onValueChanged={v => this.setState({ psw: v.value })}
                                />
                            </SimpleItem>

                            {this.state.mode === 'new_psw' && this.state.logonPage.passwordChangeMethod === 'can_change' &&
                                < SimpleItem colSpan={60}>
                                    <Label>
                                        تکرار رمز عبور:
                                    </Label>
                                    <TextBox mode='password'
                                        //----------- onValueChange={e => this.setState({ message: ' ' })}
                                        value={this.state.psw2} onValueChanged={v => this.setState({ psw2: v.value })}
                                    />
                                </SimpleItem>
                            }
                            {/*------- 
                            <SimpleItem colSpan={12}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span style={{ padding: '1rem' }}>
                                        <Button text='ورود' width='10rem' height='50px' />
                                    </span>
                                    <TextBox width='10rem' onValueChanged={v => this.setState({ enteredCaptcha: v })} />
                                    <ClientCaptcha captchaCode={code => { this.captchaCode = code }} />
                                </div>
                             </SimpleItem> -------
                            */}

                            {/* {false && needsCaptcha &&
                                <SimpleItem colSpan={30}>
                                    <TextBox placeholder='کپچا' onValueChanged={v => this.setState({ enteredCaptcha: v.value })} />
                                </SimpleItem>
                            } */}
                            {needsCaptcha &&
                                <SimpleItem colSpan={60}>
                                    <Captcha key={'captch_' + this.state.captchaKeyCounter}
                                        sid='logon'
                                        ref={el => this.captchaComponent = el}
                                        userName={this.state.userName}
                                    />
                                </SimpleItem>
                            }
                            {/* 
                            {false && needsCaptcha &&
                                <SimpleItem colSpan={30}>
                                    <ClientCaptcha key={'captcha' + this.state.counter} //----height={50}
                                        captchaCode={code => this.captchaCode = code} />
                                </SimpleItem>
                            } */}

                            <SimpleItem colSpan={60}>
                                <div style={{
                                    color: 'red',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%',
                                    //display: this.state.message?.length > 0 ? 'block' : 'none',
                                    height: '3rem',
                                    padding: '0.5rem',
                                }}>
                                    {this.state.message ?? '&nbsp;'}
                                </div>
                            </SimpleItem>

                            {this.state.mode === 'new_psw' && this.state.logonPage.passwordChangeMethod === 'can_change' &&
                                <SimpleItem colSpan={30}>
                                    <Button text='ثبت' width='95%' //-------height='50px'
                                        onClick={this.onNewPassword}
                                    />
                                </SimpleItem>
                            }
                            {this.state.mode !== 'new_psw' &&
                                <SimpleItem colSpan={30}>
                                    <Button text='ورود' width='95%' //-------height='50px'
                                        onClick={this.onLogon}
                                    />
                                </SimpleItem>
                            }
                            {this.state.mode !== 'new_psw' && this.state.logonPage.passwordChangeMethod === 'can_change' && //this.state.userName?.length > 0 &&
                                <SimpleItem colSpan={30}>
                                    <Button text='تغییر رمز عبور'
                                        width='95%' //-------height='50px'
                                        onClick={() => this.setState({ mode: 'new_psw' })}
                                    />
                                </SimpleItem>
                            }
                            {this.state.mode !== 'new_psw' && this.state.logonPage.passwordChangeMethod === 'can_reset' && //this.state.userName?.length > 0 &&
                                <SimpleItem colSpan={30}>
                                    <Button text='فراموشی رمز عبور'
                                        width='95%' //-------height='50px'
                                        onClick={() => this.onForgotPassword()}
                                    />
                                </SimpleItem>
                            }
                            {this.state.mode === 'new_psw' && this.state.logonPage.passwordChangeMethod === 'can_change' && //this.state.userName?.length > 0 &&
                                <SimpleItem colSpan={30}>
                                    <Button text='انصراف'
                                        width='95%' //-------height='50px'
                                        onClick={() => this.setState({ mode: 'logon' })}
                                    />
                                </SimpleItem>
                            }

                        </Form>
                    }
                </div >

                {this.state.logonPage.passwordChangeMethod === 'can_reset' &&
                    <UniPopup
                        visible={this.state.resetPswPopupVisible} onClose={() => this.setState({ resetPswPopupVisible: false })}
                        okText='بازنشانی پسورد' cancelText='انصراف' title='بازنشانی رمز عبور'
                        onOk={() => this.onResetPassword()}
                    >
                        <Form rtlEnabled={true} colCount={60}
                        >
                            <SimpleItem colSpan={60}>
                                <Label>
                                    کد پرسنلی:
                                </Label>
                                <TextBox
                                    //----- onValueChange={e => this.setState({ message: ' ' })}
                                    value={this.state.userName} onValueChanged={v => this.setState({ userName: v.value })}
                                />
                            </SimpleItem>
                            <SimpleItem colSpan={60}>
                                <Label>
                                    کد ملی:
                                </Label>
                                <TextBox
                                    //------- onValueChange={e => this.setState({ message: ' ' })}
                                    value={this.state.nationalno} onValueChanged={v => this.setState({ nationalno: v.value })}
                                />
                            </SimpleItem>
                            <SimpleItem colSpan={60}>
                                <Label>
                                    شماره موبایل:
                                </Label>
                                <TextBox
                                    //------- onValueChange={e => this.setState({ message: ' ' })}
                                    value={this.state.mobile} onValueChanged={v => this.setState({ mobile: v.value })}
                                />
                            </SimpleItem>
                            {this.state.resetPswPopupVisible &&
                                <SimpleItem colSpan={60}>
                                    <Captcha key={'caprsp_' + this.state.captchaKeyCounter + '_' + this.state.resetPswPopupVisible}
                                        ref={el => this.captchaForResetPassword = el} sid='rsp'
                                        userName={'_reset_password_' + this.state.userName?.toLocaleUpperCase()}
                                    />
                                </SimpleItem>
                            }
                        </Form>
                    </UniPopup>
                }
            </>
        );
    }
}

export default WtLogon;